module.exports = "<template> <contingent-set value.two-way=field.value field.bind=field></contingent-set> </template> ";